import {
    Stepper,
    Step,
    StepLabel,
    Button,
    Box,
    Typography,
    TextField,
} from '@mui/material';
import { Search } from '@mui/icons-material';
export default function Footer() {
    return (
        <div class="container-fluid footer py-1 wow fadeIn" data-wow-delay="0.2s">
            <div class="container ">
                <div class="row ">
                    <div class="col-xl-17">
                        <div class="mb-10">
                            <div class="row ">
                               <div  className="col-md-6" class="d-flex justify-content-center align-items-center">
                            Copyright @ Al Sagr Insurance 2025 |<a href="https://www.alsagrins.ae/terms-and-conditions/" 
                            class="footer-link">Terms and Conditions</a> | <a href="https://www.alsagrins.ae/privacy-policy-2/"class="footer-link">
                                Privacy Policy</a> | Powered by Al Sagr Insurance Company Registration No: 41370  
                            </div>
                            </div>
                           
                        </div>
                      
            

                    </div>
                </div>
            </div>
        </div>


    )

}